const messageFileEventReducer = (state = { new_uievent: {} }, payload) => {
	switch (payload.type) {
		case 'MESSAGE_FILE_PUBLISH':
			return { ...state, new_uievent: payload.event };
		default:
			return state;
	}
};

export default messageFileEventReducer;